import React from "react";

const EulaMarketingText = (props) => {
  return (
    <>
      <table>
        <thead>
          <tr>
            <th>목적</th>
            <th>항목</th>
            <th>보유기간</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              (주)모빌리전트가 제공하는 이용자 맞춤형 서비스 및 상품 추천, 각종
              경품 행사, 이벤트 등의 광고성 정보 제공(이메일, 서신우편, SMS 등)
            </td>
            <td>이름, 이메일주소, 휴대전화번호, 마케팅 수신 동의 여부</td>
            <td>회원 탈퇴 후 30일 또는 동의 철회 시까지</td>
          </tr>
        </tbody>
      </table>
      <p>
        본 마케팅 정보 수신에 대한 동의를 거부하실 수 있으며, 이 경우 회원가입은
        가능하나 일부 서비스 이용 및 각종 광고, 할인, 이벤트 및 이용자 맞춤형
        상품 추천 등의 서비스 제공이 제한될 수 있습니다.
      </p>
    </>
  );
};

export default EulaMarketingText;
